module.exports = __webpack_public_path__ + "static/media/short-time-to-go.0554b66d.txt";